import {FaGoogle} from 'react-icons/fa'
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { firebaseConfig } from "../../../utils/constant";
import { initializeApp } from "firebase/app";
import { LOADING_UI, SET_ERRORS, UNLOADING_UI } from '../../../redux/types'
import './social-button.scss';
import { UseAppDispatch } from '../../../redux/store'

interface ISocialButton{
  className?:string;
  loginSocial: Function;
}
const SocialButton = (props: ISocialButton) => {
  const dispatch = UseAppDispatch();
  let classes = 'social-button';
  if(props.className){
    classes+=' '+props.className;
  }
  const app = initializeApp(firebaseConfig);
  const googleSignIn = () => {
    dispatch({
      type:LOADING_UI
    });
    const provider = new GoogleAuthProvider();
    provider.addScope('email,profile');
    const auth = getAuth();
    signInWithPopup(auth, provider)
      .then(async (result) => {
        const user: any = result.user;
        await props.loginSocial({
          login_source: 'google',
          token: user?.accessToken ?? null,
          email: user.providerData[0].email,
          fullname: user.providerData[0].displayName,
          google_id: user.providerData[0].uid
        })
      }).catch((error) => {
        dispatch({
          type: SET_ERRORS,
          payload: {
            error:true,
            message: 'Something Wrong. Please Try Again'
          }
        });
      }).finally(()=>{
        dispatch({
          type:UNLOADING_UI
        });
      });
  }
  return (
    <div className={classes}>
      <button type="button" onClick={googleSignIn} className="bg-transparent border-0 p-0">
        <FaGoogle size={'2rem'}/>
      </button>
    </div>
  )
}
export default SocialButton;
